export default class FormOption {
    public value: string | null = null;
    public label = "انتخاب از لیست";

    constructor(value?: string | null, label?: string,) {
        if (value) {
            this.value = value;
        }
        if (label) {
            this.label = label;
        }
    }
}